/**
 * Las etiquetas del cliente. **Dos de trabajo, más la de quien no escribe.**
 *
 * Eran cinco y dos no existían: ningún documento devuelve «Dueño» ni
 * «Jefatura» (`ROLE_BY_AUTHORITY`, de los dos lados, no las nombra), así que la
 * pantalla las ofrecía, el servidor las guardaba como `crm_admin` y
 * `crm_operator`, y la fila volvía diciendo «Administrador» y «Ejecutivo». Una
 * etiqueta que nadie vuelve a ver es peor que una que falta.
 *
 * Hoy el cliente tiene dos: **`admin`**, que trabaja los registros y administra
 * su organización, y **`user`**, que trabaja los registros. `viewer` no es una
 * tercera jerarquía sino el nombre de no poder escribir: lo llevan las cuentas
 * de sólo lectura del cliente y también, proyectado, el soporte de Ribox. Hay
 * una prueba que lo sostiene contra `access.WRITE_ROLES` del servidor
 * (`tests/api/test_v2_roles.py`).
 */
export const USER_ROLES = ['admin', 'user', 'viewer'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Administrador',
  user: 'Usuario',
  viewer: 'Sólo lectura',
};

/**
 * Dos estados, no tres, y el que falta se sacó a propósito.
 *
 * `invited` estuvo acá y no significaba nada: **no hay servicio de correo
 * detrás de esta aplicación**, así que nadie recibía una invitación y el
 * servidor guardaba esas cuentas como activas. La tabla mostraba «Invitado»
 * sobre una cuenta que ya podía entrar, y la pantalla ofrecía reenviar un
 * enlace que no existía.
 *
 * Hoy una cuenta nace con su contraseña puesta y mostrada una sola vez, así que
 * no hay un estado intermedio que nombrar: o tiene acceso o no lo tiene. Hay
 * una prueba en `tests/api/test_v2_users.py` que falla si esta lista y la del
 * servidor dejan de decir lo mismo.
 */
export const USER_STATUSES = ['active', 'disabled'] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

/** «Cuenta», no «usuario»: es la cuenta la que está activa o desactivada. */
export const USER_STATUS_LABELS: Record<UserStatus, string> = {
  active: 'Activa',
  disabled: 'Desactivada',
};

export type {
  CredencialDeCelular,
  IssuedUser,
  NumerosExcluidos,
  Team,
  TeamCreate,
  TeamUpdate,
  User,
  UserCreate,
  UserUpdate,
} from './schemas/user';
